module.exports = {"cookies":"Cookie","help":"說明","privacy":"隱私","signInButtonText":"以 Adobe ID 登入","termsOfUse":"使用條款","updated":"更新"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/zh_tw.json
// module id = 952
// module chunks = 0